import { render, staticRenderFns } from "./EventPopupCategoryHeader.vue?vue&type=template&id=513f2a81&scoped=true&"
import script from "./EventPopupCategoryHeader.vue?vue&type=script&lang=ts&"
export * from "./EventPopupCategoryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EventPopupCategoryHeader.vue?vue&type=style&index=0&id=513f2a81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f2a81",
  null
  
)

export default component.exports